import { StaticImage } from 'gatsby-plugin-image';
import { Box } from '@hover/blueprint';
import React from 'react';
import { ICustomerQuote } from '../interfaces/ICustomerQuote';

export const INSURANCE_CUSTOMERS_QUOTE_DATA: Array<ICustomerQuote> = [
  {
    header: 'Benson property restores homes faster with HOVER',
    quote:
      'The 3D model allows us to show the homeowner that their home can look even better than before once it’s restored. We can turn the overall negative experience of suffering home damage into a more hopeful one',
    name: 'Anne Benson',
    role: 'owner and president, benson property',
    image: (
      <StaticImage
        placeholder="blurred"
        src="../assets/images/insurance_case_study_1.png"
        alt="benson-property"
        objectFit="contain"
      />
    ),
    logo: (
      <Box w="80px" h="40px">
        <StaticImage
          placeholder="blurred"
          src="../assets/images/benson_property_logo.png"
          alt="benson-property-logo"
          objectFit="contain"
        />
      </Box>
    ),
    id: 1,
  },
  {
    header: 'The roof strategist uses HOVER for a more efficient process ',
    quote:
      'When you use HOVER you have the roof measurements and 3D model ready for the adjuster while he or she is on-site assessing the damage of the home and putting together what is known as the scope of loss.',
    name: 'Adam Bensman',
    role: 'sales & Marketing consultant, The Roof Strategist',
    image: (
      <StaticImage
        placeholder="blurred"
        src="../assets/images/insurance_case_study_2.png"
        alt="the-roof-strategist"
        style={{ maxWidth: 340 }}
        objectFit="contain"
      />
    ),
    logo: (
      <Box w="162px" h="43px">
        <StaticImage
          src="../assets/images/the_roof_logo.png"
          alt="the-roof-strategist-logo"
          objectFit="contain"
        />
      </Box>
    ),
    id: 2,
  },
];
